<template>
  <div class="pos-cart d-flex flex-column">

    <!-- Buscador -->
    <div class="pc-search-row position-relative">
      <div class="flex-grow-1 position-relative">
        <svg class="pc-search-ic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input
          ref="searchInput"
          v-model="busqueda"
          @keydown.enter.prevent="onEnter"
          @input="onInput"
          @focus="mostrarDrop = resultados.length > 0"
          @blur="cerrarConDelay"
          type="text"
          class="pc-search"
          placeholder="Buscar producto, código de barras o SKU…"
          autocomplete="off"
        />
        <div v-if="buscando" class="pc-search-spin">
          <div class="spinner-border spinner-border-sm text-primary" style="width:14px;height:14px"></div>
        </div>
        <div v-if="mostrarDrop && resultados.length" class="search-drop">
          <div v-for="item in resultados" :key="item.idpres"
            class="drop-item d-flex justify-content-between align-items-center"
            @mousedown.prevent="agregar(item)">
            <div class="d-flex align-items-center gap-2 min-w-0">
              <div class="pc-avatar">{{ inicial(item.producto) }}</div>
              <div class="min-w-0">
                <div class="pc-drop-name">{{ item.producto }}</div>
                <div class="pc-drop-sub">{{ item.presentacion }}<span v-if="item.talla"> · {{ item.talla }}</span></div>
              </div>
            </div>
            <div class="text-end ms-3 flex-shrink-0">
              <div class="pc-drop-price">S/ {{ Number(item.precvta).toFixed(2) }}</div>
              <div :class="item.stock > 0 ? 'pc-stock-ok' : 'pc-stock-no'">stock: {{ item.stock }}</div>
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="pc-scan-btn" @click="$refs.searchInput.focus()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M4 7V5a1 1 0 0 1 1-1h2M4 17v2a1 1 0 0 0 1 1h2M20 7V5a1 1 0 0 0-1-1h-2M20 17v2a1 1 0 0 1-1 1h-2"/>
          <line x1="7" y1="8" x2="7" y2="16"/><line x1="10" y1="8" x2="10" y2="16"/><line x1="13" y1="8" x2="13" y2="16"/><line x1="17" y1="8" x2="17" y2="16"/>
        </svg>
        Escanear
      </button>
    </div>

    <!-- Encabezado detalle -->
    <div class="pc-detail-head d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <span class="pc-detail-title">Detalle de venta</span>
        <span v-if="carrito.length" class="pc-items-badge">Ítems: {{ carrito.length }}</span>
      </div>
      <button v-if="carrito.length" type="button" class="pc-clear" @click="$emit('limpiar')">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        Limpiar
      </button>
    </div>

    <!-- Tabla / carrito -->
    <div class="flex-grow-1 overflow-auto">
      <div v-if="!carrito.length" class="pc-empty text-center">
        <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" style="opacity:.18">
          <path d="M4 7V5a1 1 0 0 1 1-1h2M4 17v2a1 1 0 0 0 1 1h2M20 7V5a1 1 0 0 0-1-1h-2M20 17v2a1 1 0 0 1-1 1h-2"/>
          <line x1="7" y1="8" x2="7" y2="16"/><line x1="10" y1="8" x2="10" y2="16"/><line x1="14" y1="8" x2="14" y2="16"/><line x1="17" y1="8" x2="17" y2="16"/>
        </svg>
        <div class="pc-empty-txt">Escanea o busca un producto para comenzar</div>
      </div>

      <table v-else class="table align-middle mb-0 pos-tbl">
        <thead class="sticky-top">
          <tr>
            <th class="ps-3" style="min-width:220px">PRODUCTO</th>
            <th class="text-center" style="width:118px">CANT.</th>
            <th class="text-end" style="width:110px">P. FINAL</th>
            <th class="text-end" style="width:70px">DSC %</th>
            <th class="text-end pe-2" style="width:100px">SUBTOTAL</th>
            <th style="width:34px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in carrito" :key="idx">
            <td class="ps-3">
              <div class="d-flex align-items-center gap-2">
                <div class="pc-avatar">{{ inicial(item.producto) }}</div>
                <div class="min-w-0">
                  <div class="pc-row-name">{{ item.producto }}</div>
                  <div class="pc-row-sub">
                    {{ item.presentacion }}<span v-if="item.talla"> · {{ item.talla }}</span>
                    <span v-if="item.codbarras"> · {{ item.codbarras }}</span>
                  </div>
                  <div v-if="item.stock === 0" class="pc-row-warn text-danger">Sin stock</div>
                  <div v-else-if="item.cantidad > item.stock" class="pc-row-warn text-warning">⚠ Stock insuf. ({{ item.stock }})</div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="pc-stepper">
                <button type="button" @click="item.cantidad > 1 && (item.cantidad--, recalc(item))">−</button>
                <input type="number" min="1"
                  class="pc-qty"
                  v-model.number="item.cantidad"
                  @change="recalc(item)" />
                <button type="button" class="pc-step-plus" @click="item.cantidad++; recalc(item)">+</button>
              </div>
            </td>
            <td class="text-end">
              <div v-if="item.precFinal < item.precvta" class="pc-etq">S/ {{ Number(item.precvta).toFixed(2) }}</div>
              <input type="number" min="0" step="0.01"
                class="pc-price"
                :class="item.precFinal < item.precvta ? 'is-dsc' : ''"
                v-model.number="item.precFinal"
                @change="onPrecioChange(item)" />
            </td>
            <td class="text-end">
              <input type="number" min="0" max="100" step="1"
                class="pc-dsc"
                :class="item.pctDsc > 0 ? 'is-dsc' : ''"
                v-model.number="item.pctDsc"
                @change="onDscChange(item)"
                placeholder="0" />
            </td>
            <td class="text-end pc-subtotal pe-2">
              S/ {{ subtotal(item).toFixed(2) }}
            </td>
            <td>
              <button type="button" class="pc-trash" @click="$emit('quitar', idx)" title="Quitar">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Total -->
    <div v-if="carrito.length" class="pc-total d-flex justify-content-end align-items-baseline gap-3">
      <span class="pc-total-lbl">Total</span>
      <span class="pc-total-val">S/ {{ totalCarrito.toFixed(2) }}</span>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api';

export default {
  name: 'PosCart',
  props: {
    carrito:   { type: Array, required: true },
    idalmacen: { type: Number, default: 1 },
  },
  emits: ['agregar', 'quitar', 'limpiar'],
  data() { return { busqueda: '', resultados: [], buscando: false, mostrarDrop: false, timer: null }; },
  computed: {
    totalCarrito() { return this.carrito.reduce((s, i) => s + this.subtotal(i), 0); },
  },
  mounted() { this.$nextTick(() => this.$refs.searchInput?.focus()); },
  methods: {
    inicial(nombre) { return (nombre || '?').trim().slice(0, 2).toUpperCase(); },
    subtotal(item) { return (item.precFinal || 0) * (item.cantidad || 1); },
    recalc(item) { if (item.cantidad < 1) item.cantidad = 1; },
    onPrecioChange(item) {
      if (item.precFinal < 0) item.precFinal = 0;
      item.pctDsc = item.precvta > 0
        ? Math.max(0, parseFloat((((item.precvta - item.precFinal) / item.precvta) * 100).toFixed(1)))
        : 0;
    },
    onDscChange(item) {
      if (item.pctDsc < 0) item.pctDsc = 0;
      if (item.pctDsc > 100) item.pctDsc = 100;
      item.precFinal = parseFloat((item.precvta * (1 - item.pctDsc / 100)).toFixed(2));
    },
    onInput() {
      const q = this.busqueda.trim();
      if (q.length < 2) { this.resultados = []; this.mostrarDrop = false; return; }
      clearTimeout(this.timer);
      if (/^\d+$/.test(q)) return;
      this.timer = setTimeout(() => this.buscarTexto(q), 300);
    },
    async onEnter() {
      const q = this.busqueda.trim(); if (!q) return;
      clearTimeout(this.timer);
      if (/^\d{6,}$/.test(q)) await this.buscarBarcode(q);
      else await this.buscarTexto(q);
    },
    async buscarTexto(q) {
      this.buscando = true;
      try {
        const res = await api.get('/productos', { params: { q, limit: 30, publicado: false, idalmacen: this.idalmacen } });
        this.resultados = (res.data.data || []).filter(p => p.idpres).map(p => ({
          idpres: p.idpres, idprod: p.idprod, producto: p.nombre,
          presentacion: p.pres_nombre || 'Unidad',
          talla: p.talla && p.talla !== 'Sin Especificar' ? p.talla : null,
          codbarras: p.codbarras || null,
          precvta: parseFloat(p.precvta) || 0, stock: parseFloat(p.stock) || 0,
        }));
        this.mostrarDrop = true;
      } catch { this.resultados = []; } finally { this.buscando = false; }
    },
    async buscarBarcode(code) {
      this.buscando = true;
      try {
        const res = await api.get(`/productos/barcode/${encodeURIComponent(code)}`, { params: { idalmacen: this.idalmacen } });
        this.agregar(res.data.data); this.busqueda = '';
      } catch { alert('Código no encontrado'); } finally { this.buscando = false; }
    },
    cerrarConDelay() { setTimeout(() => { this.mostrarDrop = false; }, 150); },
    agregar(item) {
      this.$emit('agregar', {
        idpres: item.idpres, idprod: item.idprod, producto: item.producto,
        presentacion: item.presentacion, talla: item.talla || null,
        codbarras: item.codbarras || null, codigo: item.codigo || null,
        precvta: parseFloat(item.precvta) || 0, stock: parseFloat(item.stock) || 0,
      });
      this.busqueda = ''; this.resultados = []; this.mostrarDrop = false;
      this.$nextTick(() => this.$refs.searchInput?.focus());
    },
  },
};
</script>

<style scoped>
.pos-cart { background:#fff; border:1px solid #e5e7eb; border-radius:12px; overflow:hidden; }

/* Buscador */
.pc-search-row { display:flex; gap:8px; padding:12px; border-bottom:1px solid #eef1f4; }
.pc-search-ic { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:#94a3b8; pointer-events:none; }
.pc-search {
  width:100%; height:42px; padding:0 12px 0 38px; font-size:15px;
  background:#f8fafc; border:1px solid #e5e7eb; border-radius:8px; color:#0f172a; outline:none; transition:.15s;
}
.pc-search::placeholder { color:#94a3b8; }
.pc-search:focus { background:#fff; border-color:#1d4ed8; box-shadow:0 0 0 3px rgba(29,78,216,.12); }
.pc-search-spin { position:absolute; right:12px; top:50%; transform:translateY(-50%); }
.pc-scan-btn {
  display:flex; align-items:center; gap:6px; white-space:nowrap; flex-shrink:0;
  background:#1d4ed8; color:#fff; border:none; border-radius:8px; padding:0 16px; font-size:14px; font-weight:600; cursor:pointer; transition:.15s;
}
.pc-scan-btn:hover { background:#1e40af; }

/* Dropdown resultados */
.search-drop { position:absolute; left:0; right:0; top:calc(100% + 4px); z-index:300; background:#fff; border:1px solid #e5e7eb; border-radius:10px; box-shadow:0 8px 24px rgba(15,23,42,.12); max-height:360px; overflow-y:auto; }
.drop-item { cursor:pointer; padding:9px 12px; border-bottom:1px solid #f4f6f8; transition:background .1s; }
.drop-item:last-child { border-bottom:none; }
.drop-item:hover { background:#eff5ff; }
.pc-drop-name { font-size:14px; font-weight:600; color:#0f172a; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.pc-drop-sub { font-size:12px; color:#94a3b8; }
.pc-drop-price { font-size:14px; font-weight:700; color:#1d4ed8; }
.pc-stock-ok { font-size:11px; color:#16a34a; }
.pc-stock-no { font-size:11px; color:#dc2626; }

/* Encabezado detalle */
.pc-detail-head { padding:12px 14px 8px; }
.pc-detail-title { font-size:15px; font-weight:600; color:#0f172a; }
.pc-items-badge { background:#e6f0ff; color:#1d4ed8; font-size:12px; font-weight:600; padding:2px 10px; border-radius:20px; }
.pc-clear { display:flex; align-items:center; gap:4px; background:none; border:none; color:#dc2626; font-size:12px; font-weight:600; cursor:pointer; }
.pc-clear:hover { color:#b91c1c; }

/* Vacío */
.pc-empty { padding:56px 20px; color:#94a3b8; }
.pc-empty-txt { font-size:15px; margin-top:12px; }

/* Avatar / inicial */
.pc-avatar { width:34px; height:34px; border-radius:8px; background:#eef2ff; color:#1d4ed8; display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:600; flex-shrink:0; }
.min-w-0 { min-width:0; }

/* Tabla */
.pos-tbl thead th { background:#f8fafc; color:#64748b; font-size:11px; font-weight:600; letter-spacing:.4px; border:none; padding:9px 6px; }
.pos-tbl tbody tr { border-bottom:1px solid #f4f6f8; }
.pos-tbl tbody tr:hover { background:#fafbfc; }
.pc-row-name { font-size:14px; font-weight:600; color:#0f172a; line-height:1.25; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:260px; }
.pc-row-sub { font-size:11px; color:#94a3b8; }
.pc-row-warn { font-size:11px; font-weight:600; }

/* Stepper cantidad */
.pc-stepper { display:inline-flex; align-items:center; gap:4px; }
.pc-stepper button { width:26px; height:28px; border:1px solid #e5e7eb; background:#fff; border-radius:6px; font-size:16px; line-height:1; color:#64748b; cursor:pointer; transition:.1s; }
.pc-stepper button:hover { background:#f1f5f9; }
.pc-stepper button.pc-step-plus { color:#1d4ed8; border-color:#c7d7fb; }
.pc-stepper button.pc-step-plus:hover { background:#eff5ff; }
.pc-qty { width:40px; height:28px; text-align:center; font-size:14px; font-weight:600; border:1px solid #e5e7eb; border-radius:6px; color:#0f172a; outline:none; }
.pc-qty:focus { border-color:#1d4ed8; }

/* Precio y descuento por ítem */
.pc-etq { font-size:11px; color:#cbd5e1; text-decoration:line-through; }
.pc-price { width:88px; height:30px; text-align:right; font-size:14px; font-weight:600; border:1px solid #e5e7eb; border-radius:6px; color:#0f172a; outline:none; padding:0 8px; }
.pc-price:focus { border-color:#1d4ed8; }
.pc-price.is-dsc { color:#dc2626; }
.pc-dsc { width:58px; height:30px; text-align:right; font-size:13px; font-weight:600; border:1px solid #e5e7eb; border-radius:6px; color:#94a3b8; outline:none; padding:0 8px; }
.pc-dsc:focus { border-color:#1d4ed8; }
.pc-dsc.is-dsc { color:#dc2626; }
.pc-subtotal { font-size:15px; font-weight:700; color:#0f172a; }

/* Trash */
.pc-trash { background:none; border:none; color:#cbd5e1; cursor:pointer; padding:4px; transition:.1s; }
.pc-trash:hover { color:#dc2626; }

/* Total */
.pc-total { padding:14px 16px; border-top:1px solid #eef1f4; background:#fafbfc; }
.pc-total-lbl { font-size:14px; color:#64748b; }
.pc-total-val { font-size:22px; font-weight:800; color:#1d4ed8; }
</style>
